import React from 'react'
import {NullAsDefault, renderIf} from 'views/Shared'
import {CurriculumActionTypes} from 'views/AppLocals/Course'
import {BsClock} from 'react-icons/bs'

export const renderCurriculum = ({
    translate: t,
    renderContextMenu = NullAsDefault,
    handleAction = NullAsDefault,
} = {}) => (item, index) => {

    const {title, description, duration_months, subjects = []} = item ?? {}

    return (
        <div key={index} className="p-4 flex flex-col custom-item-render relative list-item">
            <div className="flex flex-wrap items-center gap-2 leading-none">
                <h2
                    onClick={() => handleAction(CurriculumActionTypes.CURRICULUM_READ, item)}
                    className="font-bold text-base text-gray-800 tracking-wide hover:text-primary cursor-pointer leading-none">
                    {title}
                </h2>
                {renderIf(
                    duration_months > 0,
                    <span className="inline-flex items-center gap-1 px-2 py-1 bg-blue-50 border border-blue-200 rounded-full text-sm font-medium text-blue-600 tracking-wide leading-none">
                        <BsClock size={12}/>
                        {`${t('duration')}: ${duration_months} ${t('months')}`}
                    </span>
                )}
            </div>
            <div className="mt-1 mb-2 border-b border-color-50" />
            {renderIf(
                subjects.length > 0,
                <div className="flex flex-wrap gap-2">
                    {subjects.map((s, i) => (
                        <span
                            key={s.id || i}
                            className="px-2 py-1 bg-slate-50 border border-slate-200 rounded-full text-sm font-medium text-slate-500 tracking-wide leading-tight">
                            {s.title}
                            {s.number_of_sessions > 0 && (
                                <span className="ml-1 font-medium text-slate-400 italic">
                                    {`(${s.number_of_sessions}${t('sessions')[0]})`}
                                </span>
                            )}
                        </span>
                    ))}
                </div>
            )}

            {renderIf(
                description,
                <div className="mt-2 text-color-300 tracking-wider text-sm max-lines-2">
                    {description}
                </div>
            )}

            <div className="absolute right-5 top-5 contextIcon">
                {renderContextMenu(item)}
            </div>
        </div>
    )
}
